import * as yup from 'yup';

export interface AffinityFormValues {
  apiKey: string;
}

export function affinityConfigSchema() {
  return yup.object({
    apiKey: yup.string().trim().required('API key is required'),
  });
}

export function getDefaultAffinityConfig(): AffinityFormValues {
  return {
    apiKey: '',
  };
}
